
<div class="container">
    <div class="content">
        <div class="header mb-1">
            Compound
          </div>
          <app-generic-write-table
              [formArray]="form.get('compound')" [columns]="compoundColumns"
              [canAddNewItem]="false"
              tableMinHeight="unset"
              #table
          >
          </app-generic-write-table>

        <div class="header mt-5 mb-1">
          Ingredients
        </div>
        <app-generic-write-table
            [formArray]="form.get('ingredients')" [columns]="ingredientColumns"
            [canAddNewItem]="false"
            tableMinHeight="80px"
            #table
        >
        </app-generic-write-table>

        <div class="header mt-5 mb-1" *ngIf="form.get('waste')?.length">
            Wastes
        </div>
        <app-generic-write-table *ngIf="form.get('waste')?.length"
            [formArray]="form.get('waste')" [columns]="ingredientColumns"
            [canAddNewItem]="false"
            tableMinHeight="80px"
        >
        </app-generic-write-table>
    </div>  
